<template>
  <el-popover
    ref="popoverRef"
    popper-class="user-popper"
    placement="bottom-end"
    width="254"
    trigger="click"
    @show="showPopoverHandler"
  >
    <template #reference>
      <el-button icon="el-icon-user-solid" type="text"></el-button>
    </template>
    <div>
      <!-- userInfo -->
      <div class="handler-item mb-4px w-full p-16px">
        <div class="text-base text-text-primary font-600 leading-24px">{{ userInfo.nickName }}</div>
        <div class="text-12px text-text-regular leading-20px">{{ userInfo.deptName || '-' }}</div>
      </div>
      <!-- 切换账号 -->
      <el-dropdown-item v-if="boundUsers.length > 0" @mousedown.native="switchVisible = true">
        切换账号
      </el-dropdown-item>
      <!-- 操作列表 -->
      <el-dropdown-item v-if="userInfo.userName === 'admin'" @mousedown.native="simulationVisible = true">
        模拟用户
      </el-dropdown-item>
      <el-dropdown-item
        v-if="adminTempToken !== null && adminTempToken !== '' && adminTempToken !== undefined"
        @mousedown.native="cancelSimulationUser"
      >
        取消模拟
      </el-dropdown-item>
      <el-dropdown-item v-for="item in handlerItem" :key="item.command" @mousedown.native="doHandler(item.command)">
        {{ item.label }}
      </el-dropdown-item>
      <cat-dialog :visible.sync="simulationVisible" :has-fullscreen="false" title="模拟用户" @confirm="simulationUser">
        <div class="mx-auto flex">
          <el-select
            v-model="simulationUserInfo"
            class="mx-auto mt-12 w-200px"
            placeholder="请选择模拟用户"
            clearable
            filterable
          >
            <el-option v-for="user in userList" :key="user.userId" :value="`${user.userName}`" :label="user.nickName" />
          </el-select>
        </div>
      </cat-dialog>
      <cat-dialog
        :visible.sync="switchVisible"
        width="800px"
        :has-fullscreen="false"
        title="切换账号"
        @confirm="switchUser"
      >
        <div v-loading="loading" class="mx-auto w-600px">
          <!-- <el-select
            v-model="switchUserId"
            class="mx-auto mt-12 w-200px"
            placeholder="请选择切换用户"
            clearable
            filterable
          >
            <el-option
              v-for="user in boundUsers"
              :key="user.userId"
              :value="user.userId"
              :label="user.nickName + ' - ' + user.deptName"
            />
          </el-select> -->
          <div class="my-16px">请选择账号</div>
          <div class="user-card-list">
            <div
              v-for="user in boundUsers"
              :key="user?.userId"
              :class="['user-card', switchUserId === user?.userId ? 'active' : '']"
              @click="switchUserId = user?.userId"
            >
              <div class="flex items-center">
                <el-radio v-model="switchUserId" :label="user?.userId">&nbsp;</el-radio>
                <div>
                  <div>登录账号：{{ user?.userName || '-' }}</div>
                  <div>用户名称：{{ user?.nickName || '-' }}</div>
                  <div class="flex">
                    <div class="shrink-0">组织机构：</div>
                    <div>{{ user?.deptName || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </cat-dialog>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { Message, MessageBox } from 'element-ui';
import { simulationLogin, switchUserLogin } from '@/api/login';
import { useBoundUsers } from '@/views/system/user/components/useBoundUsers';
const emits = defineEmits(['command']);
const userStore = useUserStore();
const { userInfo } = storeToRefs(userStore);
const userList = computed(() => userStore.userList);
const popoverRef = ref<any>(null);
const simulationVisible = ref<boolean>(false);
const simulationUserInfo = ref<any>(null);
const adminTempToken = getAdminTempToken();
const handlerItem = ref([
  {
    command: 'userInfo',
    label: '个人信息设置',
  },
  {
    command: 'logout',
    label: '退出登录',
  },
]);
const doHandler = (command: string) => {
  popoverRef.value.doClose();
  emits('command', command);
};
const simulationUser = () => {
  // 获取管理员的token,缓存到cookie中
  if (simulationUserInfo.value !== null) {
    simulationLogin(simulationUserInfo.value).then((res: any) => {
      Message.success('模拟成功');
      if (adminTempToken === null || adminTempToken === '' || adminTempToken === undefined) {
        setAdminTempToken(getToken() as string);
      }
      setToken(res.token);
      useRouterStore().resetRouter();
      location.reload();
    });
  } else {
    Message.error('请先选择用户');
  }
};
const cancelSimulationUser = () => {
  MessageBox.confirm('您确定不再进行用户模拟吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      simulationVisible.value = false;
      setToken(adminTempToken);
      Message.success('已取消模拟');
      setAdminTempToken('');
      useRouterStore().resetRouter();
      location.reload();
    })
    .catch(() => {});
};

// 显示弹窗时，获取关联账号列表
const showPopoverHandler = () => {
  if (userInfo.value.userId) {
    switchUserId.value = userInfo.value.userId;
    fetchBoundUsers(userInfo.value.userId);
  }
};

const router = useRouter();
// 切换账号
const { boundUsers, fetchBoundUsers, loading } = useBoundUsers();
const switchVisible = ref<boolean>(false);
const switchUserId = ref<any>(null);
const switchUser = () => {
  if (switchUserId.value !== null) {
    const userName = boundUsers.value.find((user: any) => user.userId === switchUserId.value)?.userName;
    switchUserLogin(userName).then((res: any) => {
      Message.success('切换成功');
      setToken(res.token);
      useRouterStore().resetRouter();
      router.push('/');
      location.reload();
    });
  } else {
    Message.error('请先选择用户');
  }
};
onMounted(() => {
  userStore.getUserList();
});
</script>

<style lang="scss" scoped>
.handler-item {
  box-shadow: 0 -1px 0 #f4f4f4 inset;
}

.user-card-list {
  .user-card {
    border: 2px solid #e6e8ee;
    border-radius: 6px;
    padding: 24px;
    cursor: pointer;

    :deep(.el-radio__inner) {
      border-color: #e6e8ee;
      border-width: 2px;
    }

    :deep(.el-radio__input.is-checked .el-radio__inner) {
      border-width: 1px;
    }
  }

  .user-card:not(:last-child) {
    margin-bottom: 16px;
  }

  .user-card.active {
    border-color: var(--color-primary);
  }
}
</style>
<style lang="scss">
.el-popover.user-popper {
  top: 56px !important;
  padding: 0;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #e6e8ee;
  box-shadow: 0 0 6px #57678b47;
  background-color: white;
}
</style>
